/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_No_Integrations_DescriptionInputs */



/**
* | output |
* | --- |
* | "No integration in this installation exposes tools that can be restricted." |
*
* @param {Rights_Tools_No_Integrations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_no_integrations_description = /** @type {((inputs?: Rights_Tools_No_Integrations_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_No_Integrations_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Integration in dieser Installation stellt Tools bereit, die eingeschränkt werden können.")
	return /** @type {LocalizedString} */ ("No integration in this installation exposes tools that can be restricted.")
});